import axios from "axios";
import _ from "lodash";
import axiosRetry from "axios-retry";

axiosRetry(axios, { retries: 3 });

const state = {
  selectedArea: {},
  division: [
    { label: "Imaging (Regions)", value: "Imaging" },
    { label: "Diagnostic (Regions)", value: "Diagnostics" },
    { label: "Imaging (Zones)", value: "ImagingZone" },
  ],
  selectedDivision: { label: "Imaging (Regions)", value: "Imaging" },
  areas: [],

  colorCoding: {
    0: "#c7522a",
    5: "#cb6036",
    10: "#cf6e41",
    1: "#d68a58",
    6 : "#da9864",
    11: "#dea66f",
    2: "#e5c185",
    7: "#f0daa5",
    12: "#fbf2c4",
    3: "#dae0b8",
    8: "#b8cdab",
    13: " #74a892",
    4: "#008585",
    9: "#007070",
    14: "#006767",
  },
};

const getters = {
  division: (state) => state.division,
  selectedDivision: (state) => state.selectedDivision,
  areas: (state) => state.areas,
  selectedArea: (state) => state.selectedArea,
};

const mutations = {
  setSelectedDivision(state, val) {
    state.selectedDivision = { ...val };
  },
  setAreas(state, obj) {
    state.areas = [...obj];
  },
  setSelectedArea(state, obj) {
    state.selectedArea = _.cloneDeep(obj);
  },
};

const actions = {
  async loadAreas({ commit, rootGetters, state, dispatch }) {
    try {
      const res = await axios.get(
        rootGetters.backendURL +
          "/api/service_areas/" +
          rootGetters.selectedCountry.iso_3166_1
      );
      // console.log(axios.defaults.headers.common);
      let mappedColorArr = res.data.map((obj) => ({
        ...obj,
        color: state.colorCoding[obj.color_index],
      }));

      commit("setAreas", mappedColorArr);
    } catch (err) {
      console.log(err);
      dispatch("pushNotification", {
        type: "error",
        label: "Get Areas failed",
        text: "Areas unavailable",
        duration: "long",
      });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
